import { render, staticRenderFns } from "./ButtonWithLoader.vue?vue&type=template&id=7b971a76&scoped=true&"
import script from "./ButtonWithLoader.vue?vue&type=script&lang=js&"
export * from "./ButtonWithLoader.vue?vue&type=script&lang=js&"
import style0 from "./ButtonWithLoader.vue?vue&type=style&index=0&id=7b971a76&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b971a76",
  null
  
)

export default component.exports